import React, {useEffect, useState} from "react";
import {  useOutletContext } from "react-router-dom";
import BasePermissionWrapper from "../../../../components/partials/restricted/base-permission-wrapper";
import {
    getPermission,
    permissionGroup,
    permissionType,
} from "../../../../constants/permissions";
import {getShippingTracks, putShipping, putShippingImporter} from "../../../../api/shipping";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {getFormattedDate} from "../../../../utils/timeUtils";
import {ClockIcon, LocationMarkerIcon, MapIcon} from "@heroicons/react/outline";
import {SEA} from "../../../../constants/config";
import toast from "react-hot-toast";
import {useForm} from "react-hook-form";
import InputText from "../../../../components/common/form/input-text";
import InputSubmit from "../../../../components/common/form/input-submit";

const ShippingTracking = () => {

  // get Shipping
  const { shippingDetail, shippingType,  setShippingDetail} = useOutletContext();
  const { loggedCompany, isExporter } = useSelector((state) => state.user);
  const [isFetchListLoading, setFetchListLoading] = useState(true);
  const [trackingDetail, setTrackingDetail] = useState({});

    // edit shipping
    const [isEditShippingLoading, setEditShippingLoading] = useState(false);


    const { t } = useTranslation();

    useEffect(() => {
        function fetchList() {
            if (loggedCompany && shippingType.type === SEA) {
                setFetchListLoading(true);
                getShippingTracks({ company_id: loggedCompany.id, shipping_id: shippingDetail.id })
                    .then((response) => {
                        setTrackingDetail(response);
                        setFetchListLoading(false);
                    })
                    .catch((e) => {
                        setTrackingDetail({});
                        setFetchListLoading(false);
                    });
                }
        }

        fetchList();
    }, [loggedCompany, shippingDetail, shippingType]);

    let code = (trackingDetail && trackingDetail.live_map_url) ? new URL(trackingDetail.live_map_url).searchParams.get("query") : false;


    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm({ mode: "onBlur" });

    useEffect(() => {
        if(shippingDetail !== null){
            setValue('tracking_link', shippingDetail.tracking_link);
        }

        // eslint-disable-next-line
    }, [shippingDetail]);


    const onSubmit = async (data) => {
        if (loggedCompany) {
            data["id"] = shippingDetail.id;
            setEditShippingLoading(true);
            (isExporter ? putShipping({ company_id: loggedCompany.id, shipping_id: shippingDetail.id, data }) :
                putShippingImporter({ company_id: loggedCompany.id, shipping_id: shippingDetail.id, data }))
                .then((response) => {
                    setShippingDetail(response);
                    setEditShippingLoading(false);
                    toast.success(t("app.shippings.update_success"))
                })
                .catch((e) => {
                    toast.error(e.message)
                    setEditShippingLoading(false);
                });
        }
    };

    return (
        <BasePermissionWrapper
            requiredPermissions={[getPermission(permissionGroup.SHIPPING, permissionType.EDIT)]}
            renderBaseOnFail={true}
            redirectWrongCompanyType={true}
        >

            <form onSubmit={handleSubmit(onSubmit)}>
                <div
                    className="bg-white p-3 space-y-6  rounded-md shadow  sm:overflow-hidden mb-4">
                    <fieldset>
                        <div className="space-y-4">
                            <div className="sm:flex sm:w-full   space-x-2">
                                <div className="w-full">
                                    <InputText
                                        id={"tracking_link"}
                                        type={"text"}
                                        errors={errors.tracking_link}
                                        input={{
                                            ...register("tracking_link", {required: false}),
                                        }}
                                        label={t("app.booking.tracking_link")}
                                    />
                                </div>
                                <InputSubmit isLoading={isEditShippingLoading} label={t("app.form.save")}
                                             extraClassName={"h-10 rounded self-end content-end"}/>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </form>


            {
                (shippingType.type === SEA && shippingDetail && shippingDetail.track_shipping === true) && (
                    <>
                        {
                            ((isFetchListLoading && trackingDetail !== false) || code === false) ? (
                                <div
                                    className="border bg-solitude-400 shadow-md rounded-lg p-4 h-32 w-full mx-auto  flex before:flex-1 after:flex-1 flex-col items-center">
                                    <div className="animate-pulse border border-gray-500 rounded-full p-4">
                                        <LocationMarkerIcon className="text-gray-500 h-6 w-6 stroke-current stroke-1"/>
                                    </div>
                                </div>
                            ) : (
                                <div className="block w-full shadow-md aspect-w-10 aspect-h-10 rounded-lg overflow-hidden">
                                    <iframe
                                        id="IframeShipsgoLiveMap"
                                        src={`https://shipsgo.com/iframe/where-is-my-container/${code}?tags=hide-search-box`}
                                        title="Shipsgo Live Map"
                                        style={{width: '100%', height: '400px', border: 'none'}}
                                    />
                                </div>
                            )
                        }


                        <div className="mt-5">
                            <div className="bg-white border shadow-md rounded-lg p-4">
                                <h4 className="sr-only">Status</h4>

                                <p className="text-sm font-medium text-blue-1000"> {t("app.shipping_tracking.tracking_progress")}</p>


                                <div className="mt-6" aria-hidden="true">
                                    <div className="overflow-hidden rounded-full bg-gray-200">
                                        <div className="h-2 rounded-full bg-blue-1000"
                                             style={{width: (trackingDetail?.tracking_percentage ?? 0) + '%'}}/>
                                    </div>

                                    <div
                                        className={trackingDetail.delayed ? "mt-3  grid-cols-3 text-sm font-medium text-gray-600 grid" : "mt-3  grid-cols-2 text-sm font-medium text-gray-600 grid"}>
                                        <div className="">
                                            <div className="flex items-center">

                                                <div>
                                        <span
                                            className={'flex-shrink-0 inline-flex relative items-center justify-center h-10 w-10 rounded-md bg-blue-1000'}>
                                            <span className="font-medium leading-none text-white">
                                                <MapIcon className={'h-5 w-5 text-blue-100'}/>
                                            </span>
                                        </span>
                                                </div>
                                                <div className="ml-3">
                                                    <p className="text-sm font-medium text-blue-1000 group-hover:text-gray-900 uppercase">
                                                        <b>{getFormattedDate(shippingDetail.departure_date)}</b></p>
                                                    <p className="text-xs font-medium text-gray-900 group-hover:text-gray-700">{shippingDetail?.departure_port?.name ?? ''}</p>
                                                </div>
                                            </div>

                                        </div>

                                        {
                                            trackingDetail.delayed && (
                                                <div className="text-center mt-3">
                                         <span
                                             className={'flex-shrink-0 inline-flex  items-center text-sm font-medium  text-red-700'}>
                                                <ClockIcon className={'h-5 w-5  mr-2'}/>
                                             {
                                                 trackingDetail.delay > 1 ? (
                                                     t("app.shipping_tracking.delay_days", {days: trackingDetail.delay})
                                                 ) : (
                                                     t("app.shipping_tracking.delay_day", {days: trackingDetail.delay})
                                                 )
                                             }
                                        </span>
                                                </div>
                                            )
                                        }


                                        <div className="text-right">
                                            <div className="flex justify-end items-center">

                                                <div className="mr-3">
                                                    <p className="text-sm font-medium text-blue-1000 group-hover:text-gray-900 uppercase">
                                                        <b>{getFormattedDate(shippingDetail.arrival_date)}</b></p>
                                                    <p className="text-xs font-medium text-gray-900 group-hover:text-gray-700">{shippingDetail?.arrival_port?.name ?? ''}</p>
                                                </div>

                                                <div>
                                        <span
                                            className={'flex-shrink-0 inline-flex relative items-center justify-center h-10 w-10 rounded-md bg-blue-1000'}>
                                            <span className="font-medium leading-none text-white">
                                                <MapIcon className={'h-5 w-5 text-blue-100'}/>
                                            </span>
                                        </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>

                    </>
                )
            }


            {
                (shippingDetail.track_shipping === false && shippingDetail.tracking_link) && (
                    <>

                        <div
                            className="block w-full shadow-md aspect-w-10 aspect-h-10 rounded-lg overflow-hidden">
                            <iframe
                                src={shippingDetail.tracking_link}
                                title="Live Map"
                                style={{width: '100%', height: '600px', border: 'none'}}
                            />
                        </div>
                    </>
                )
            }


        </BasePermissionWrapper>
    );
};

export default ShippingTracking;
